import { DanceManagerUserRoleEnum, DanceSchoolToUserInterface } from '../../..';

export class UpdateDanceSchoolToUserRequestDto
  implements DanceSchoolToUserInterface {
  userId: string;
  danceSchoolUserRole: DanceManagerUserRoleEnum;
  isPublic?: boolean;
}
